import type { SVGProps } from 'react';
const SvgPencilSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.018 3.393H3.393c-.73 0-1.322.591-1.322 1.321v11.893c0 .73.592 1.322 1.322 1.322h11.893c.73 0 1.321-.592 1.321-1.322v-4.625"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m10.657 12.593-3.963.71.66-3.998 6.908-6.844a1.32 1.32 0 0 1 1.446-.288c.16.066.307.164.43.288l1.4 1.394a1.314 1.314 0 0 1 0 1.868z"
    />
  </svg>
);
export default SvgPencilSquare;
